<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { BellIcon, EyeIcon, EyeOffIcon } from '@heroicons/vue/outline'
import { useStore } from '@admin_js/store'
import { onClickOutside } from '@vueuse/core'
import { ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'

const target = ref(null)

onClickOutside(target, (event) => (open.value = false))

const store = useStore()
const open = ref(false)

const markAsRead = (notification) => {
  axios
    .post(
      route('api.notifications.mark-as-read', {
        notification: notification.notification.id,
      })
    )
    .then(() => store.markNotificationAsRead(notification))
    .catch(() => store.markNotificationAsUnread(notification))
}
</script>

<template>
  <Menu ref="target" as="div" class="relative inline-block text-left">
    <div>
      <MenuButton>
        <BellIcon
          @click="open = !open"
          class="mt-1.5 h-6 w-6"
          aria-hidden="true"
        />
        <span
          v-if="store.numberOfUnreadNotifications > 0"
          class="absolute top-0 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-600 text-xxs text-white"
          >{{
            store.numberOfUnreadNotifications > 9
              ? '9+'
              : store.numberOfUnreadNotifications
          }}</span
        >
      </MenuButton>
    </div>

    <div v-show="open">
      <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <MenuItems
          static
          class="absolute right-0 mt-2 w-96 origin-top-right cursor-default rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div class="divide-y divide-gray-200">
            <MenuItem
              v-if="store.numberOfUnreadNotifications"
              as="div"
              v-for="notification in store.getNotifications"
              :key="notification.id"
              class="flex items-center justify-between py-4 px-4 hover:bg-slate-50"
            >
              <div class="w-full">
                <div
                  class="mb-1 mb-2 flex max-w-full justify-between rounded-sm bg-sky-500 px-1 py-0.5 text-xs uppercase text-white"
                  :title="notification.source_id"
                >
                  <span>
                    {{ notification.source }}
                  </span>
                  <span v-if="notification.type != 'None'">
                    {{ notification.type }}
                  </span>
                </div>
                <div class="flex items-center justify-between">
                  <div>
                    <div class="mb-5 text-sm">
                      {{ notification.message }}
                    </div>
                    <div class="mt-2 text-xs text-gray-500">
                      {{ notification.time }}
                    </div>
                    <div
                      v-if="notification.count > 1"
                      class="mt-2 text-xs text-gray-500"
                    >
                      Herhaling: {{ notification.count }}
                    </div>
                  </div>
                  <div class="ml-4" title="Markeer als gelezen">
                    <EyeIcon v-if="notification.read" class="h-6 w-6" />
                    <EyeOffIcon
                      v-else
                      @click="markAsRead(notification)"
                      class="h-6 w-6 cursor-pointer hover:text-gray-700"
                    />
                  </div>
                </div>
              </div>
            </MenuItem>
            <MenuItem
              v-else
              as="div"
              class="flex items-center justify-between py-2 px-2"
            >
              Je hebt geen ongelezen notificaties
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </div>
  </Menu>
</template>
